import React, { Component } from 'react';
import {localization} from '../../Frames/localization'

import {materialThemeField} from '../../../src/App'
import { ThemeProvider } from "@material-ui/styles";

import Grid from '@material-ui/core/Grid';
import DatePickerStart from '../../Elements/Pickers/DatePickerStart'
import DatePickerEnd from '../../Elements/Pickers/DatePickerEnd'
import {SelectCard,SelectPointOfSale,SelectType, SelectPeriod} from '../../Elements/Select/selectOperations'
import { Paper, Divider } from '@material-ui/core';
import Button from "../../Elements/Button/buttons";
class filterOperation extends Component
{
    constructor(props)
    {
        super(props)
        this.onClick = this.onClick.bind(this)
    }
    onClick()
    {
        this.props.onSubsmit();
    }
    render(){
        const res = this.props.res;
        var tr = {
            Beginning: localization.GetTranslate('Operations.Beginning'),
            End: localization.GetTranslate('Operations.End'),
            Update: localization.GetTranslate('buttons.Update'),
            PointOfSale: localization.GetTranslate('Operations.Point of sale'),
            Type: localization.GetTranslate('Operations.Type'),
            Card: localization.GetTranslate('Operations.Card'),
            Period: localization.GetTranslate('Operations.Period')
        }
        return(
            <div>
                <Paper className="FilterOperationBox">
                <Divider />
                    <Grid container justify="center" spacing={3}>
                        
                        <Grid item xs={"auto"}>
                            <ThemeProvider theme={materialThemeField}>
                            <DatePickerStart
                             label={tr.Beginning} 
                             className="dataPickerSet"
                             setstartDate={this.props.setstartDate}
                             value={this.props.startDate}></DatePickerStart>
                             </ThemeProvider>
                        </Grid>
                        <Grid item xs={"auto"}>
                            <ThemeProvider theme={materialThemeField}>
                            <DatePickerEnd
                            label={tr.End} 
                            className="dataPickerSet"
                            setendDate={this.props.setendDate}
                            value={this.props.endDate}></DatePickerEnd>
                            </ThemeProvider>
                        </Grid>
                        
                        <Grid item xs={"auto"}>
                        <ThemeProvider theme={materialThemeField}>
                            <SelectPeriod value={this.props.period} selectPeriod={this.props.selectPeriod} textLabel={tr.Period} className="selectFilter" classNamelabel="selectFilterLabel"></SelectPeriod>
                        </ThemeProvider>
                        </Grid>
                        <Grid item xs={"auto"}>
                        <Button
                                disabled={this.props.asyncDisabled}
                                onClick={this.onClick}
                                variant="contained"
                                type="submit"
                                value="submit"
                                color="primary"
                                textLabel={tr.Update}
                                className="SaveButton"
                            >
                        </Button> 
                        </Grid>          
                    </Grid>
                    <Divider />
                    <Grid container justify="center" spacing={3}>
                    
                        <Grid item xs={"auto"}>
                        <ThemeProvider theme={materialThemeField}>
                            <SelectPointOfSale selectPointofSale={this.props.selectPointofSale} res={res} textLabel={tr.PointOfSale} className="selectFilter" classNamelabel="selectFilterLabel"></SelectPointOfSale>
                        </ThemeProvider>
                        </Grid>
                        {/* <Grid item xs={"auto"}>
                        <ThemeProvider theme={materialThemeField}>
                            <SelectType  selectType={this.props.selectType} res={res} textLabel={tr.Type} className="selectFilter" classNamelabel="selectFilterLabel"></SelectType>
                            </ThemeProvider>
                        </Grid> */}
                        <Grid item xs={"auto"}>
                        <ThemeProvider theme={materialThemeField}>
                            <SelectCard selectCard={this.props.selectCard} res={res} value={res.data.cardCode} textLabel={tr.Card} className="selectFilter" classNamelabel="selectFilterLabel"></SelectCard>
                            </ThemeProvider>
                        </Grid>
                        <Grid item xs={"auto"}>
                        </Grid>    
                             
                    </Grid>
                </Paper>
            </div>
        );
    }
}
export default filterOperation;